module.exports = __webpack_public_path__ + "img/logo.5b36be3c.svg";